export default __webpack_public_path__ + "static/media/KX-TG6812GB_D_gallery_global_01.b782806b.jpg";